<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{title}}</span>
      <span>
        <slot name="header-btn"></slot>
      </span>
    </div>
    <slot />
  </el-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '每月日程'
      }
    }
  }
</script>

<style lang="less" scoped>
  .el-card {
    height: 100%;
    .clearfix {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

  }
  /deep/ .el-card__header {
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    font-size: 14px;
    color: #043170;
    background-color: #F1F3F7;
    .el-select {
      width: 100px;
    }
  } 
  /deep/ .el-card__body {
    padding: 5px;
    height: calc(100% - 55px);
  }
</style>